import React from "react";
import { format } from "date-fns";
import { inspectionRowWrapper, templateName, unitName, linkStyle, progressBarWrapper } from '../styles';
import { recurringDays, formatPrice } from 'utils';

export const InspectionRow = ({ inspection, status, report }) => {

  return (
    <tr style={inspectionRowWrapper}>
      <td>
        <div style={templateName}>
          {inspection.template}
        </div>
      </td>
      <td>{inspection.property} {inspection.unit ? inspection.unit : null}</td>
      {status !== 'recurring' ? <td>{inspection.has_charges && inspection.total_cost_in_cents !== null ? `$${formatPrice((inspection.total_cost_in_cents / 100), true)}` : '-'}</td> : null}
      <td>
        <a style={linkStyle}>
          {inspection.created_by}
        </a>
      </td>
      {!report ? <td>{format(status === 'open' || status === 'recurring' ? inspection.creation_date : status === 'completed' ? inspection.completion_date : inspection.cancellation_date, 'MM/dd/yyyy')}</td> : null}
      <td>
        {inspection.assigned_to ?
          <a style={linkStyle}>
            {inspection.assigned_to}
          </a> : 'Unassigned'
        }
      </td>
      {report ? <td>{inspection.creation_date ? format(new Date(inspection.creation_date), 'MM/dd/yyyy') : ''}</td> : null}
      {report ? <td>{inspection.status}</td> : null}
      {status === 'open' && !report ? <td>{inspection.due_date ? format(new Date(inspection.due_date), 'MM/dd/yyyy') : ''}</td> : null}
      {!report ? <td>
        {status !== 'recurring' ?
          <div style={progressBarWrapper}>
            <div style={{
              width: `${((inspection.completed_items + inspection.started_items) / inspection.num_items) * 100}%`,
              background: '#FFC700',
              height: 13,
              borderRadius: 60,
              position: 'absolute',
              left: 0
            }} />
            <div style={{
              width: `${(inspection.completed_items / inspection.num_items) * 100}%`,
              background: window?.settings?.primary_color ?? '#1DBD6B',
              height: 13,
              borderRadius: 60,
              position: 'absolute',
              left: 0
            }} />
            <div></div>
          </div> :
          <div style={unitName}>
            {recurringDays(inspection.schedule)}
          </div>
        }
      </td> : null}
    </tr >
  )
}